export interface QSetDetailsHeaderModalContextData {
  setAction: (action: QSetDetailsHeaderModalAction | null) => void;
}

export enum QSetDetailsHeaderModalAction {
  DELETE = 'DELETE',
  DUPLICATE = 'DUPLICATE',
  EXPORT = 'EXPORT',
}
